import { ProtocolIcon } from './chunk-YR6ZOFOZ.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function ProtocolCardTitle({ protocolId, icon, label }) {
  return /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-2", children: [
    /* @__PURE__ */ jsx(ProtocolIcon, { protocolId, icon }),
    /* @__PURE__ */ jsx("span", { className: "text-sm font-semibold", children: label })
  ] });
}

export { ProtocolCardTitle };
//# sourceMappingURL=chunk-CTMMF4LG.js.map
//# sourceMappingURL=chunk-CTMMF4LG.js.map